<div class="container">
  <div class="items">
    @for (item of items; track trackBy($index, item)) {
      <div
        class="item"
        [class.disabled]="disabled"
        [class.active]="value === item.value"
        (click)="onItemClick(item)">
        <ppl-svg-icon
          [icon]="item.icon"
          width="20"
          height="20"></ppl-svg-icon>
        <span>{{ item.label }}</span>
      </div>
    }
  </div>
  <div class="content">
    <ng-content></ng-content>
  </div>
</div>
